import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import FaqAccordion from '@/components/base/FaqAccordion';
import { testimonials } from '@/mocks/testimonials';
import { faqs } from '@/mocks/faqs';

export default function SocialSections() {
  return (
    <>
      <section className="bg-background-100">
        <div className="mx-auto max-w-content px-4 py-16 md:px-6 md:py-20">
          <SectionHeading
            eyebrow="使用者反馈"
            title="他们在这里找到了合适的入口"
            description="来自消费维权用户、同城创作者与内容写作者的真实使用感受。"
          />
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {testimonials.map((item) => (
              <figure
                key={item.name}
                className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-accent-400"></i>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  {item.content}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-semibold text-secondary-800">
                    {item.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block font-heading text-sm font-medium text-foreground-950">{item.name}</span>
                    <span className="block text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section id="faq" className="border-b border-background-200 bg-background-50">
        <div className="mx-auto max-w-content px-4 py-16 md:px-6 md:py-20">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.8fr_1.2fr]">
            <div>
              <SectionHeading
                eyebrow="常见问题"
                title="关于这个导航，你可能想知道"
                description="如果你还有其他疑问，可以直接通过联系我们页面留言。"
              />
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-chat-1-line"></i>还有问题，去留言
              </Link>
            </div>
            <FaqAccordion items={faqs.slice(0, 6)} />
          </div>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="mx-auto max-w-content px-4 py-16 md:px-6 md:py-20">
          <div className="relative overflow-hidden rounded-lg bg-primary-900 px-6 py-12 md:px-14 md:py-16">
            <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full border border-primary-700/60"></div>
            <div className="pointer-events-none absolute -bottom-20 right-24 h-40 w-40 rounded-full border border-primary-700/50"></div>
            <div className="relative max-w-2xl">
              <p className="text-xs font-medium tracking-[0.18em] text-accent-300">发现入口失效或线索投不出去？</p>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
                告诉我们，一起把这份目录维护得更好
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-background-200 md:text-base">
                无论是入口改版、渠道不再受理，还是你希望补充某个类别，都可以通过联系我们页面反馈，
                我们会在核实后更新条目，并回复处理结果。
              </p>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-primary-950 transition-colors hover:bg-accent-400 cursor-pointer"
                >
                  <i className="ri-send-plane-line"></i>提交反馈
                </Link>
                <Link
                  to="/guide"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm text-background-100 transition-colors hover:border-accent-300 hover:text-accent-300 cursor-pointer"
                >
                  先看发布指南
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}